<template>
  <div class="newCertificate">
    <div class="gradient-bg"></div>
    <div class="content">
      <div class="year-select" @click="show = true">
        <span class="year-text">{{ year ? year : '全部' }}</span>
        <i class="iconfont iconxiajiantou year-icon"></i>
      </div>
      <div class="CertificateList">
        <!-- 使用vant的List组件实现下拉加载 -->
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :error="error"
          error-text="请求失败，点击重新加载"
          :immediate-check="false"
        >
          <div class="CertificateItem" v-for="(item, index) in certificateList" :key="index">
            <img class="CertificateImg" :src="item.imageUrl" alt="" />
            <span class="downtext">请长按证书图片下载证书</span>
          </div>
        </van-list>
      </div>
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
  </div>
</template>

<script>
import {certificateslist} from '@/api'
export default {
  data() {
    return {
      year: '',
      show: false,
      actions: (() => {
        const currentYear = new Date().getFullYear()
        const years = []

        // 添加"全部"选项
        years.push({name: '全部', value: ''})

        // 从当前年份到2020年依次添加年份选项
        for (let y = currentYear; y >= 2020; y--) {
          years.push({name: y.toString(), value: y.toString()})
        }

        return years
      })(),
      certificateList: [],
      loading: false, // 加载状态
      finished: false, // 是否加载完成
      error: false, // 是否加载错误
      page: 1, // 当前页码
      pageSize: 2, // 每页数量
      total: 0 // 总数
    }
  },

  components: {},
  mounted() {
    // 改为正确的生命周期钩子名称
    console.log(33333)

    this.onLoad()
  },
  methods: {
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false
      this.year = item.value
      console.log(item)
      this.reloadList()
    },
    // 加载数据
    async onLoad() {
      try {
        // 调用API获取数据
        const params = {
          pageNo: this.page,
          pageSize: this.pageSize,
          annual: this.year // 如果有年份筛选条件
        }
        const res = await certificateslist(params)

        if (res.success) {
          const processedList = []
          for (const item of res.data) {
            try {
              const imageUrl = await this.$divToCavasToimg(item.certificateJson, '', '', '', item.certificateSealUrl)
              processedList.push({
                ...item,
                imageUrl: imageUrl // 将生成的图片URL添加到项目中
              })
            } catch (error) {
              console.error('生成图片失败:', error)
              // 如果生成失败，使用默认图片或空字符串
              processedList.push({
                ...item,
                imageUrl: '' // 或者使用默认图片URL
              })
            }
          }
          this.certificateList.push(...processedList)
          console.log(this.certificateList, 666)

          this.total = Number(res.totalDatas)
        }
        // const response = await this.getCertificateList(params)
        // const {list, total} = response

        // // 将新数据添加到现有列表
        // this.certificateList.push(...list)

        // 更新总数
        // this.total = total

        // 判断是否加载完成
        if (this.certificateList.length >= this.total) {
          this.finished = true
        } else {
          this.page++ // 页码加1
          // 检查是否需要继续加载以填满屏幕
          this.$nextTick(() => {
            this.checkAndLoadMore()
          })
        }

        this.error = false // 重置错误状态
      } catch (error) {
        console.error('加载数据失败:', error)
        this.error = true // 设置错误状态
      } finally {
        this.loading = false // 加载状态结束
      }
    },
    async getCertificateList(params) {
      return new Promise((resolve, reject) => {
        setTimeout(async () => {
          try {
            // 模拟返回数据
            const rawList = Array.from({length: params.pageSize}, (_, index) => ({
              id: (params.page - 1) * params.pageSize + index + 1,
              name: `证书${(params.page - 1) * params.pageSize + index + 1}`,
              imagejson:
                '{"cdnUrl":"","columns":[{"filed":"fixedText","id":"172119150797412","idCardLookType":1,"label":"固定文本4","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"height":25,"letterSpacing":1,"lineHeight":1.0,"opacity":0.0,"textAlign":"left","width":200,"x":136,"y":256,"zIndex":10},"suffix":"","type":"default_txt","value":"身份证号："},{"filed":"fixedText","id":"172119141748111","idCardLookType":1,"label":"固定文本3","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"height":25,"letterSpacing":1,"lineHeight":1.0,"opacity":0.0,"textAlign":"left","width":194,"x":136,"y":738,"zIndex":9},"suffix":"","type":"default_txt","value":"登记证书编号："},{"defaultValue":"IOS-YSKJ-NO.1","filed":"certificateNo","id":"2","idCardLookType":1,"label":"证书编号1","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"height":25,"letterSpacing":1,"lineHeight":1.0,"opacity":0.0,"textAlign":"left","width":200,"x":318,"y":738,"zIndex":8},"suffix":"","type":"$9_txt","value":"DHD202500051"},{"defaultValue":"yyyy-MM-dd","filed":"awardTime","id":"4","idCardLookType":1,"label":"颁发日期1","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"height":25,"letterSpacing":1,"lineHeight":1.0,"opacity":0.0,"textAlign":"left","width":268,"x":266,"y":620,"zIndex":7},"suffix":"","type":"$6_txt","value":"2026年01月06日"},{"defaultValue":"元素科技","filed":"awardCompany","id":"1","idCardLookType":1,"label":"颁发单位落款1","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"height":25,"letterSpacing":1,"lineHeight":1.0,"opacity":0.0,"textAlign":"left","width":257,"x":266,"y":562,"zIndex":6},"suffix":"","type":"$7_txt","value":"四川省教育局"},{"filed":"fixedText","id":"17211912764906","idCardLookType":1,"label":"固定文本2","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"height":25,"letterSpacing":1,"lineHeight":1.0,"opacity":0.0,"textAlign":"left","width":200,"x":136,"y":508,"zIndex":5},"suffix":"","type":"default_txt","value":"特此证明"},{"filed":"combinedVariable","id":"17211911026855","idCardLookType":1,"label":"组合变量1","list":[{"filed":"fixedText","id":"1721191107349","idCardLookType":1,"label":"固定文本1","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"opacity":0.0},"suffix":"","type":"default_txt","value":"完成了培训项目【"},{"filed":"customFiled","id":"6","idCardLookType":1,"label":"自定义变量1","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"opacity":0.0},"suffix":"","type":"$10_txt","value":"验证当前及全部下级机构申报"},{"filed":"fixedText","id":"1721191112782","idCardLookType":1,"label":"固定文本2","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"opacity":0.0},"suffix":"","type":"default_txt","value":"】的培训，获得"},{"filed":"customFiled","id":"7","idCardLookType":1,"label":"变量","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"opacity":0.0},"suffix":"","type":"$10_txt","value":"学分"},{"filed":"fixedText","id":"1721191117387","idCardLookType":1,"label":"固定文本3","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"opacity":0.0},"suffix":"","type":"default_txt","value":"为"},{"filed":"customFiled","id":"8","idCardLookType":1,"label":"自定义变量3","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"opacity":0.0},"suffix":"","type":"$10_txt","value":"2.0学分"},{"filed":"fixedText","id":"1721191134391","idCardLookType":1,"label":"固定文本4","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"opacity":0.0},"suffix":"","type":"default_txt","value":"，特颁发此证"}],"required":1,"style":{"color":"#000","fontFamily":"微软雅黑","fontSize":"16px","fontStyle":"normal","fontWeight":400,"height":150,"letterSpacing":1,"lineHeight":2.0,"opacity":0.0,"textAlign":"left","width":397,"x":136,"y":314,"zIndex":4},"suffix":"","type":"$11_txt","value":"个人学时证书内容"},{"defaultValue":"51000000000000","filed":"userIdCard","id":"5","idCardLookType":1,"label":"身份证号1","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"height":25,"letterSpacing":1,"lineHeight":1.0,"opacity":0.0,"textAlign":"left","width":322,"x":266,"y":256,"zIndex":3},"suffix":"","type":"$2_txt","value":"510107201307223753"},{"defaultValue":"张三","filed":"username","id":"3","idCardLookType":1,"label":"颁发对象1","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"25px","fontStyle":"normal","fontWeight":700,"height":25,"letterSpacing":1,"lineHeight":1.0,"opacity":0.0,"textAlign":"left","width":200,"x":136,"y":201,"zIndex":2},"suffix":"同志：","type":"$1_txt","value":"市级审核"},{"filed":"fixedText","id":"17211909497791","idCardLookType":1,"label":"固定文本1","required":1,"style":{"color":"#000","fontFamily":"楷体","fontSize":"40px","fontStyle":"normal","fontWeight":700,"height":40,"letterSpacing":8,"lineHeight":1.0,"opacity":0.0,"textAlign":"left","width":203,"x":235,"y":122,"zIndex":1},"suffix":"","type":"default_txt","value":"学时证书"}],"height":919,"internalType":5,"opacity":1.0,"position":"relative","url": "https://picsum.photos/650/919","width":650}' // 证书图片URL
            }))

            // 为每个项目生成图片URL
            const processedList = []
            for (const item of rawList) {
              try {
                const imageUrl = await this.$divToCavasToimg(item.imagejson, '', '', '', '')
                processedList.push({
                  ...item,
                  imageUrl: imageUrl // 将生成的图片URL添加到项目中
                })
              } catch (error) {
                console.error('生成图片失败:', error)
                // 如果生成失败，使用默认图片或空字符串
                processedList.push({
                  ...item,
                  imageUrl: '' // 或者使用默认图片URL
                })
              }
            }

            resolve({
              list: processedList,
              total: 5 // 总数
            })
          } catch (error) {
            reject(error)
          }
        }, 1000)
      })
    },
    // 重新加载数据（当筛选条件变化时）
    reloadList() {
      this.page = 1
      this.certificateList = []
      this.finished = false
      this.error = false
      // this.onLoad()
    },
    // 检查是否需要继续加载更多数据以填满屏幕
    checkAndLoadMore() {
      this.$nextTick(() => {
        const windowHeight = window.innerHeight
        const listContainer = this.$el.querySelector('.van-list')
        console.log(listContainer, windowHeight)
        if (listContainer.clientHeight < windowHeight - 20 && !this.finished) {
          console.log('继续加载更多数据')
          this.onLoad()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.newCertificate {
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background: #ebeef3;
  .gradient-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 180px;
    background: linear-gradient(180deg, #4ea3ff 0%, #ebeef3 100%);
    z-index: 1;
  }

  .content {
    position: relative;
    z-index: 2;
    padding: 6px 16px 0 16px;
    .year-select {
      display: flex;
      align-items: center;
      .year-text {
        font-size: 15px;
        color: #ffffff;
      }
      .year-icon {
        font-size: 12px;
        color: #ffffff;
        margin-left: 6px;
      }
    }
    .CertificateList {
      margin-top: 12px;
      .CertificateItem {
        width: 100%;
        height: 279px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .CertificateImg {
          width: 100%;
          height: 249px;
          border-radius: 8px;
        }
        .downtext {
          font-size: 13px;
          color: #8c8c8c;
        }
      }
    }
  }
  ::v-deep .van-action-sheet {
    max-height: 50vh;
    overflow-y: auto;
  }
}
</style>
